<div class="container">
    <h1 class="mt120">{{header}}</h1>
    <hr class="mb-0" />
</div>

<div class="mainContnet">
    <div class="container">
        <!-- <span [innerHTML]="paragraphdata"></span> -->
        

        <ol class="numList" >
            
            <li *ngFor="let data of trackData">
                <a [routerLink]="booklink(data.courseId)">{{data.name}}</a>
                {{data.trackdescription}}
            </li>
            
        </ol>
        <p *ngIf="header=='Pastoral Ministry Track'">For more information about iTIM, including how to prepare for and launch an iTIM in your church, download the <a [routerLink]="['/operation-manual']">Operations Manual</a>.</p>
    </div>
    <app-static-footer></app-static-footer>
</div>

